var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCompass28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5542 14.8135C24.5542 20.6126 19.8532 25.3135 14.0542 25.3135C8.25524 25.3135 3.5542 20.6126 3.5542 14.8135C3.5542 9.01455 8.25524 4.31354 14.0542 4.31354C19.8532 4.31354 24.5542 9.01455 24.5542 14.8135ZM28.0542 14.8135C28.0542 22.5456 21.7862 28.8135 14.0542 28.8135C6.32222 28.8135 0.0541992 22.5456 0.0541992 14.8135C0.0541992 7.08156 6.32222 0.813538 14.0542 0.813538C21.7862 0.813538 28.0542 7.08156 28.0542 14.8135ZM11.9026 12.2518L20.2412 8.62601L16.6154 16.9647L8.27682 20.5903L11.9026 12.2518Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompass28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;